
/* injects from baggage-loader */

'use strict';

export default class AccountDocumentRequestsController {

	constructor($log, $stateParams, $timeout, $rootScope, $state, $window, Alerts, LoadingCover, DocumentRequest, ProductDocument) {
		'ngInject';

		this.$log = $log;
		this.$stateParams = $stateParams;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.$state = $state;
		this.$window = $window;
		this.alerts = Alerts;
		this.LoadingCover = LoadingCover;
		this.DocumentRequest = DocumentRequest;
		this.ProductDocument = ProductDocument;

		// Define the loader cover style
		this.loader_style = {
			no_background: true,
			ring_primary_color: '#585858'
		}

		this.pagination = {
			currentPage: 1,
			pageSize: 10,
			maxSize: 10
		};

		// Update state params
		this.$state.go('.', this.$stateParams, {
			notify: false
		});

		this.filter = {
			status: undefined,
			product: undefined,
			document: undefined,
			page: undefined
		};
		this.productList = [];
		this.currentProductId = '';
		this.documents = [];

		// Initialize product filters array
		this.productFilters = [{
			label: 'All products',
			value: ''
		}];

		// Initialize document filters array
		this.documentFilters = [{
			label: 'All documents',
			value: ''
		}];

		// Build baseline query for this page
		this.filterQuery = {
			equalTo: [],
			withCount: true
		}

	}

	$onInit() {

		// Setup loading cover
		this.loadingRequestsLoadingCover = this.LoadingCover.getInstance('document-requests-loader');

		// this.loadingRequestsLoadingCover.show();

		// Build product filters array
		this.productFilters = [...this.productFilters, ...this.productList.map(p => ({
			label: p.serial_number ? `${p.name} (${p.serial_number})` : p.name,
			value: p.id
		}))];

		// Set the status filter if a valid status param is passed
		if (this.$stateParams.status && ['pending', 'approved', 'denied'].includes(this.$stateParams.status)) {
			this.filter.status = this.$stateParams.status;
		} else {
			this.filter.status = '';
			this.$stateParams.status = '';
		}

		// Set the product from querystring
		if (this.$stateParams.product) {
			this.filter.product = this.$stateParams.product;
			// this.filterChanged('product');

			// Build document filters array
			this.documentFilters = [...this.documentFilters, ...this.documents.map(doc => ({
				label: doc.label,
				value: doc.id
			}))];

		}

		// Set the document from querystring
		if (this.$stateParams.document) {
			this.filter.document = this.$stateParams.document;
		}

		// Set the page number from querystring
		if (this.$stateParams.page && parseInt(this.$stateParams.page)) {
			this.filter.page = this.$stateParams.page;
			this.pagination.currentPage = this.$stateParams.page;
		}

	}

	getDocumentPointer(id) {
		return this.documents.find(doc => doc.id === id);
	}

	getProductPointer(id) {
		return this.productList.find(doc => doc.id === id);
	}

	resetFilters() {

		// Clear filters
		this.filter = {
			status: undefined,
			product: undefined,
			document: undefined,
			page: undefined
		};

		// Reset current product
		this.currentProductId = '';

		// Clear documents
		this.documents = [];

		// Reset document filters array
		this.documentFilters = [{
			label: 'All documents',
			value: ''
		}];

		this.filterChanged();

		// Update querystring
		this.$state.go('.', this.filter, {
			notify: false
		});

	}

	async filterChanged(field) {

		this.loadingRequestsLoadingCover.show();

		// Clear documents if product changed
		if (field === 'product' && this.currentProductId !== this.filter.product) {

			// Reset current product
			this.currentProductId = '';

			// Clear documents
			this.documents = [];

			// Reset document filters array
			this.documentFilters = [{
				label: 'All documents',
				value: ''
			}];

			this.filter.document = '';

		}

		// Update querystring
		this.$state.go('.', this.filter, {
			notify: false
		});

		// Fetch document names for product if selected
		if (this.filter.product && this.currentProductId !== this.filter.product) {

			// Set the current product ID
			this.currentProductId = this.filter.product;

			// Fetch product documents
			let product = this.getProductPointer(this.filter.product);
			let documentsQuery = product.get('documents').query();
			documentsQuery.limit(1000);
			documentsQuery.select(['label']);
			this.documents = await documentsQuery.find();

			// Build document filters array
			this.documentFilters = [...this.documentFilters, ...this.documents.map(doc => ({
				label: doc.label,
				value: doc.id
			}))];

		}

		// Build "equalTo" queries
		let filterQuery = Object.keys(this.filter).reduce((query, key) => {
			if (this.filter[key]) {
				let value = this.filter[key];
				if (key === 'product') {
					value = this.getProductPointer(value);
				}
				if (key === 'document') {
					value = this.getDocumentPointer(value);
				}
				query.equalTo.push({
					key: key,
					value: value
				});
			}
			return query;
		}, { equalTo: [], withCount: true });

		// Set the current query
		this.filterQuery = filterQuery;

		// Load new requests
		this.DocumentRequest.fetchSome(filterQuery).then(res => {

			// Reset the current page
			this.pagination.currentPage = 1;

			// Assign requests and count
			this.collectionSize = res.count;
			this.documentRequests = res.results;

			// Remove loading cover and update view
			this.loadingRequestsLoadingCover.hide()
			this.$timeout(angular.noop, 10);

		});

	}


	/**
	 * Load the current page of requests matching the query
	 */
	loadNextPage() {

		// Update the query
		this.filterQuery.skip = (this.pagination.currentPage * this.pagination.pageSize) - this.pagination.pageSize;
		this.filter.page = this.pagination.currentPage;
		this.$rootScope.loading_state = true;

		// Update querystring
		this.$state.go('.', this.filter, { notify: false });

		// Load some more requests
		this.DocumentRequest.fetchSome(this.filterQuery).then(res => {

			this.$rootScope.loading_state = false;
			this.documentRequests = res.results;

			// Update the view
			this.$timeout(() => {

				// Scroll to the bottom of the navbar
				this.$window.scrollTo({
					top: 148,
					left: 0,
					behavior: 'smooth'
				});

			}, 100);

		});

	}


}



// WEBPACK FOOTER //
// ./src/app/pages/account/document-requests/account.document-requests.controller.js